import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminAuthStorageService } from './admin-auth-storage.service';

const PUBLIC_PATHS = ['/auth/admin/login', '/auth/admin/2fa/'];

export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(AdminAuthStorageService);
  const token   = storage.getToken();

  const isPublic = PUBLIC_PATHS.some(p => req.url.includes(p));

  const headers: Record<string, string> = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  if (token && !isPublic) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return next(req.clone({ setHeaders: headers }));
};
